import { useEffect } from "react";
import AmpleHireInputTag from "../../components/ample-hire-html-tags/ample-hire-input-tag";
import AmpleHireLabelTag from "../../components/ample-hire-html-tags/ample-hire-label-tag";
import M from "materialize-css";

const DateInputField = ({
  divTagCssClasses = "",
  inputTagCssClasses = "validate datepicker date-ico",
  inputTagIdAndName,
  placeholder = "Select Date: dd/mm/yy",
  value,
  onChange,
  disabled = false,
  required = false,
  labelText,
  labelCss,
  missing = false,
  ...props
}) => {
  return (
    <div className={`input-field ${divTagCssClasses}`}>
      <AmpleHireInputTag
        className={inputTagCssClasses}
        type={"text"}
        id={inputTagIdAndName}
        name={inputTagIdAndName}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        missing={missing}
        {...props}
      />
      <AmpleHireLabelTag
        className={`active ${labelCss}`}
        htmlFor={inputTagIdAndName}
        labelText={labelText}
        required={required}
      />
    </div>
  );
};

export default DateInputField;
